var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudComputing4276(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65.682 49.128 h 7.673 c 7.311 0 13.239 -5.927 13.239 -13.239 v 0 c 0 -4.481 -2.232 -8.434 -5.638 -10.829 C 80.61 15.286 72.599 7.462 62.74 7.462 c -4.962 0 -9.456 1.987 -12.746 5.201 C 46.525 5.753 39.394 1 31.135 1 c -11.659 0 -21.11 9.451 -21.11 21.11 c 0 0.761 0.045 1.511 0.123 2.251 c -4.022 2.272 -6.742 6.579 -6.742 11.528 v 0 c 0 7.311 5.927 13.239 13.239 13.239 h 7.673",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(184,202,216)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 70.409 63.294 v -2.439 c 0 -2.3 -1.865 -4.165 -4.165 -4.165 H 23.756 c -2.3 0 -4.165 1.865 -4.165 4.165 v 2.439 c 0 2.301 1.865 4.165 4.165 4.165 c -2.3 0 -4.165 1.865 -4.165 4.165 v 2.439 c 0 2.301 1.865 4.165 4.165 4.165 c -2.3 0 -4.165 1.865 -4.165 4.165 v 2.439 c 0 2.301 1.865 4.165 4.165 4.165 h 42.487 c 2.3 0 4.165 -1.865 4.165 -4.165 v -2.439 c 0 -2.3 -1.865 -4.165 -4.165 -4.165 c 2.3 0 4.165 -1.865 4.165 -4.165 v -2.439 c 0 -2.3 -1.865 -4.165 -4.165 -4.165 C 68.544 67.46 70.409 65.595 70.409 63.294 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(151,187,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.155,
    cy: 37.055,
    r: 4.995,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(151,187,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.845,
    cy: 30.645,
    r: 4.995,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(151,187,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.695,
    cy: 19.975,
    r: 4.995,
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(151,187,219)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "  matrix(1 0 0 1 0 0) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81.932 24.534 C 81.321 14.361 72.983 6.462 62.74 6.462 c -4.609 0 -8.99 1.624 -12.474 4.598 C 46.314 4.205 39.1 0 31.135 0 C 18.943 0 9.025 9.918 9.025 22.11 c 0 0.557 0.023 1.131 0.069 1.715 c -4.142 2.597 -6.688 7.161 -6.688 12.064 c 0 7.851 6.387 14.239 14.238 14.239 h 7.674 c 0.552 0 1 -0.447 1 -1 s -0.448 -1 -1 -1 h -7.674 c -6.748 0 -12.238 -5.49 -12.238 -12.239 c 0 -4.401 2.389 -8.485 6.234 -10.657 c 0.347 -0.196 0.545 -0.58 0.503 -0.976 c -0.078 -0.734 -0.118 -1.456 -0.118 -2.146 C 11.025 11.021 20.046 2 31.135 2 c 7.641 0 14.524 4.258 17.965 11.112 c 0.143 0.285 0.414 0.485 0.729 0.538 c 0.314 0.056 0.637 -0.047 0.864 -0.271 c 3.245 -3.17 7.523 -4.916 12.047 -4.916 c 9.324 0 16.887 7.306 17.217 16.633 c 0.011 0.313 0.168 0.603 0.424 0.783 c 3.265 2.296 5.214 6.039 5.214 10.011 c 0 6.749 -5.49 12.239 -12.239 12.239 h -7.673 c -0.553 0 -1 0.447 -1 1 s 0.447 1 1 1 h 7.673 c 7.852 0 14.239 -6.388 14.239 -14.239 C 87.595 31.431 85.487 27.224 81.932 24.534 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.244 55.689 H 54.778 V 41.136 l 4.173 -5.241 c 0.86 0.477 1.847 0.75 2.897 0.75 c 3.306 0 5.995 -2.689 5.995 -5.995 s -2.689 -5.995 -5.995 -5.995 s -5.995 2.689 -5.995 5.995 c 0 1.535 0.585 2.932 1.537 3.994 l -4.394 5.519 c -0.141 0.177 -0.218 0.397 -0.218 0.623 v 14.903 h -7.015 V 30.108 c 0 -0.226 -0.077 -0.446 -0.218 -0.623 l -4.394 -5.519 c 0.952 -1.062 1.537 -2.459 1.537 -3.994 c 0 -3.306 -2.689 -5.995 -5.995 -5.995 s -5.995 2.689 -5.995 5.995 s 2.689 5.995 5.995 5.995 c 1.051 0 2.038 -0.274 2.898 -0.75 l 4.172 5.241 v 25.232 h -6.542 v -8.497 c 0 -0.227 -0.077 -0.446 -0.218 -0.623 l -4.393 -5.518 c 0.952 -1.062 1.537 -2.459 1.537 -3.994 c 0 -3.306 -2.689 -5.995 -5.995 -5.995 s -5.995 2.689 -5.995 5.995 s 2.689 5.995 5.995 5.995 c 1.051 0 2.038 -0.273 2.897 -0.75 l 4.172 5.24 v 8.147 H 23.756 c -2.848 0 -5.166 2.317 -5.166 5.166 v 2.438 c 0 1.715 0.849 3.226 2.138 4.166 c -1.29 0.94 -2.138 2.451 -2.138 4.165 v 2.439 c 0 1.714 0.849 3.225 2.138 4.165 c -1.29 0.94 -2.138 2.451 -2.138 4.166 v 2.439 c 0 2.848 2.317 5.165 5.166 5.165 h 42.488 c 2.848 0 5.165 -2.317 5.165 -5.165 v -2.439 c 0 -1.715 -0.849 -3.226 -2.138 -4.166 c 1.289 -0.94 2.138 -2.451 2.138 -4.165 v -2.439 c 0 -1.714 -0.849 -3.225 -2.138 -4.165 c 1.289 -0.94 2.138 -2.451 2.138 -4.166 v -2.438 C 71.409 58.007 69.092 55.689 66.244 55.689 z M 61.849 26.655 c 2.203 0 3.995 1.792 3.995 3.995 s -1.792 3.995 -3.995 3.995 s -3.995 -1.792 -3.995 -3.995 S 59.646 26.655 61.849 26.655 z M 32.699 19.972 c 0 -2.203 1.792 -3.995 3.995 -3.995 c 2.203 0 3.995 1.792 3.995 3.995 s -1.792 3.995 -3.995 3.995 C 34.491 23.967 32.699 22.175 32.699 19.972 z M 24.157 37.057 c 0 -2.203 1.792 -3.995 3.995 -3.995 s 3.995 1.792 3.995 3.995 s -1.792 3.995 -3.995 3.995 S 24.157 39.26 24.157 37.057 z M 69.409 82.396 v 2.439 c 0 1.745 -1.42 3.165 -3.165 3.165 H 23.756 c -1.746 0 -3.166 -1.42 -3.166 -3.165 v -2.439 c 0 -1.746 1.42 -3.166 3.166 -3.166 h 42.488 C 67.989 79.229 69.409 80.649 69.409 82.396 z M 69.409 63.294 c 0 1.746 -1.42 3.166 -3.165 3.166 h -7.506 c -0.553 0 -1 0.447 -1 1 s 0.447 1 1 1 h 7.506 c 1.745 0 3.165 1.42 3.165 3.165 v 2.439 c 0 1.745 -1.42 3.165 -3.165 3.165 H 23.756 c -1.746 0 -3.166 -1.42 -3.166 -3.165 v -2.439 c 0 -1.745 1.42 -3.165 3.166 -3.165 h 22.909 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 H 23.756 c -1.746 0 -3.166 -1.42 -3.166 -3.166 v -2.438 c 0 -1.746 1.42 -3.166 3.166 -3.166 h 42.488 c 1.745 0 3.165 1.42 3.165 3.166 V 63.294 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.437 68.46 h 2.872 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 h -2.872 c -0.553 0 -1 0.447 -1 1 S 50.884 68.46 51.437 68.46 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.993 71.845 h -1.714 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 1.714 c 0.552 0 1 -0.447 1 -1 S 27.545 71.845 26.993 71.845 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.158 71.845 h -1.714 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 1.714 c 0.552 0 1 -0.447 1 -1 S 33.71 71.845 33.158 71.845 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.323 71.845 h -1.714 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 1.714 c 0.552 0 1 -0.447 1 -1 S 39.875 71.845 39.323 71.845 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.279 84.522 h 1.714 c 0.552 0 1 -0.447 1 -1 s -0.448 -1 -1 -1 h -1.714 c -0.552 0 -1 0.447 -1 1 S 24.727 84.522 25.279 84.522 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 31.444 84.522 h 1.714 c 0.552 0 1 -0.447 1 -1 s -0.448 -1 -1 -1 h -1.714 c -0.552 0 -1 0.447 -1 1 S 30.892 84.522 31.444 84.522 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 37.609 84.522 h 1.714 c 0.552 0 1 -0.447 1 -1 s -0.448 -1 -1 -1 h -1.714 c -0.552 0 -1 0.447 -1 1 S 37.057 84.522 37.609 84.522 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50.437 72.845 c 0 0.553 0.447 1 1 1 h 13.513 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 H 51.437 C 50.884 71.845 50.437 72.292 50.437 72.845 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51.437 84.522 h 13.513 c 0.553 0 1 -0.447 1 -1 s -0.447 -1 -1 -1 H 51.437 c -0.553 0 -1 0.447 -1 1 S 50.884 84.522 51.437 84.522 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26.993 61.167 h -1.714 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 1.714 c 0.552 0 1 -0.447 1 -1 S 27.545 61.167 26.993 61.167 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 33.158 61.167 h -1.714 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 1.714 c 0.552 0 1 -0.447 1 -1 S 33.71 61.167 33.158 61.167 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 39.323 61.167 h -1.714 c -0.552 0 -1 0.447 -1 1 s 0.448 1 1 1 h 1.714 c 0.552 0 1 -0.447 1 -1 S 39.875 61.167 39.323 61.167 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 64.949 61.167 H 51.437 c -0.553 0 -1 0.447 -1 1 s 0.447 1 1 1 h 13.513 c 0.553 0 1 -0.447 1 -1 S 65.502 61.167 64.949 61.167 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(45,74,117)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing4276);
export default __webpack_public_path__ + "static/media/cloud-computing-4276.13b0a1de7b0010621b9fa32adafbf0dd.svg";
export { ForwardRef as ReactComponent };